/*============================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
==============================================================================*/

var products;

if (document.querySelectorAll('.product').length > 0) {
  var productEl = '.product';
  products = JSON.parse($(productEl).find('script.ProductJson[type="application/json"]').html());
}


Shopify.updateOptionsInSelector = function (selectorIndex, parent) { 
  
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = $(parent + ' .product-form__input:eq(0) input[type="radio"]');
      break;
    case 1:
      var key = $(parent + ' .product-form__input:eq(0) input[type="radio"]:checked').val();
      var selector = $(parent + ' .product-form__input:eq(1) input[type="radio"]');
      break;
    case 2:
      var key = $(parent + ' .product-form__input:eq(0) input[type="radio"]:checked').val();
      key += ' / ' + $(parent + ' .product-form__input:eq(1) input[type="radio"]:checked').val();
      var selector = $(parent + ' .product-form__input:eq(2) input[type="radio"]');
  }
  var availableOptions = Shopify.optionsMap[key];
 
 
var size=  $(parent + ' .product-form__input:eq(0) input[type="radio"]:checked').val();
  var color=  $(parent + ' .product-form__input:eq(1) input[type="radio"]:checked').val();
  var ilength=  $(parent + ' .product-form__input:eq(2) input[type="radio"]:checked').val();
  
  
  if(products!=undefined && products.variants!=undefined)
  {
    products.variants.forEach(function(variant) {
      
    	if(variant.option1==size && variant.option2==color && variant.option3==ilength)
        {
        	$("#product-barcode").html(variant.barcode);
        }
	});
  	
  }
 
  //console.log('key: ',key);
  $(parent + ' .product-form__input:eq(' + selectorIndex + ') input[type="radio"]').each(function () {
   
    //console.log(availableOptions);
    if ($.inArray($(this).val(), availableOptions) !== -1) {
      $(this).removeClass('soldout');
    }
    else {
      $(this).addClass('soldout');
    }
  
  });
};





Shopify.linkOptionSelectors = function (product, parent) {
  // Building our mapping object.  
  Shopify.optionsMap = {};
  for (var i = 0; i < product.variants.length; i++) {
    var variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
      Shopify.optionsMap['root'].push(variant.option1);
      Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option2);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        var key = variant.option1 + ' / ' + variant.option2;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option3);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1) Shopify.updateOptionsInSelector(1, parent);
  if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
  // When there is an update in the first dropdown.
  $(parent + " .product-form__input:eq(0) input").change(function () {
    Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);

    return true;
  });
  // When there is an update in the second dropdown.
  $(parent + " .product-form__input:eq(1) input").change(function () {
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
  
  $(parent + " .product-form__input:eq(2) input").change(function () {
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
  
 
};
if (document.querySelectorAll('.product').length > 0) {
  var productEl = '.product';
  var product = JSON.parse($(productEl).find('script.ProductJson[type="application/json"]').html());
  if (product.options.length > 1) {
    Shopify.linkOptionSelectors(product, productEl);
  }
}

function soldoutIndecator() {    
  if ($('.product-single').length){
    var $productForms = $('.product-single').find('.product_form');
    //$productForms.addClass('is-visible');

    //Loop through each product and set the initial option value state

    $productForms.each(function(){
     
      var JSONData = $(this).data('product');
      var productID = $(this).data('product-id');
      var productSection = '.product-single';
      var swatchOptions = $(this).find('.swatch_options .swatch');
      if (swatchOptions.length > 1){
        // console.log(JSONData);
        Shopify.linkOptionSelectors(JSONData, productSection);
      }
    });
  }

  //Add click event when there is more than one product on the page (eg. Collection in Detail)
  $('body').on('click', '.swatch-element', function(){
     
    var swatchValue = $(this).data('value').toString();
    //console.log(swatchValue);
    /*$(this)
    .siblings('input[value="'+ swatchValue.replace(/\"/g,'\\"') +'"]')
    .prop("checked", true)
    .trigger("change");*/

    var JSONData = $(this).parents('.product_form').data('product');
    var productID = $(this).parents('.product_form').data('product-id');
    var productSection = '.product-' + productID + ' .product-single';
    var swatchOptions = $(this).parents('.product_form').find('.swatch_options .swatch');
    
    if (swatchOptions.length > 1){      
      Shopify.linkOptionSelectors(JSONData, productSection);
    }
  });
};


//====================Mac Script
 
// if(navigator.platform.match('Mac') !== null) {
//   $(document).ready(function(){

//     var $brower = /chrom(e|ium)/.test(navigator.userAgent.toLowerCase());
//     console.log('$brower', $brower);
//     if($brower) {
//       $('body').addClass('window-OSX');
//     }
    
//   });
// }